import {DateRange} from '@hconnect/uikit/src/common'
import moment from 'moment-timezone'

export const useEquipmentStatsDateRange = (timezone: string): DateRange<Date> => {
  const now = new Date()
  const startOfToday = moment.utc(now).tz(timezone).startOf('day')
  const equipmentStatisticsMonth = startOfToday.clone().startOf('month').month()

  // special case for january
  if (equipmentStatisticsMonth === 0) {
    return {
      from: startOfToday.clone().subtract(1, 'month').startOf('month').toDate(),
      to: startOfToday.clone().subtract(1, 'month').endOf('month').toDate()
    }
  }

  return {
    from: startOfToday.clone().startOf('year').toDate(),
    to: startOfToday.clone().subtract(1, 'month').endOf('month').toDate()
  }
}
